import React, { useState, useEffect } from "react";

//user import

import { Route, Routes } from "react-router-dom";
import { Box, Grid } from "@mui/material";

//user import

import { Sidebar } from "./components";
import { adminroutes } from "../../pages/AdminPortal/routes";
import PrivateRoute from "../../Services/Routes/APP/PrivateRoute";
import CustomAppBar from "../../components/CustomAppBar";
import { useLocation } from "react-router-dom";
//components

function AdminPortal() {
	const location = useLocation();
	let navigationsArray = location?.pathname?.split("/") || [];
	navigationsArray?.reverse().pop();
	const urlNavPoints = navigationsArray;
	const urlEndingPoint = urlNavPoints[0];
	urlNavPoints?.reverse();
	const urlStartPoint = navigationsArray[0];
	//states
	const CONTENT_PAGE_EL = document.getElementById("content-page");

	const [mobileOpen, setMobileOpen] = useState(false);
	const [showCustomAppBar, setShowCustomAppBar] = useState(false);
	const [showMobileSideBar, setShowMobileSideBar] = useState(false);
	const [contentPageMinHeight, setContentPageMinHeight] = useState(0);

	//functions

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	useEffect(() => {
		if (urlNavPoints?.length === 2) {
			setShowCustomAppBar(true);
		} else {
			setShowCustomAppBar(false);
		}
		if (urlEndingPoint === "nodeView") {
			setShowMobileSideBar(true);
		} else {
			showMobileSideBar && setShowMobileSideBar(false);
		}
	}, [urlNavPoints]);

	useEffect(() => {
		setContentPageMinHeight(
			window.innerHeight - (CONTENT_PAGE_EL?.previousSibling?.offsetHeight || 0)
		);
	}, [CONTENT_PAGE_EL]);

	//render

	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar
				handleDrawerToggle={handleDrawerToggle}
				mobileOpen={mobileOpen}
				sideBarMenuShow={showMobileSideBar}
			/>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					width: {
						md: "calc(100% - 20rem)",
						sm: "100%",
						xs: "100%",
					},
				}}
			>
				<CustomAppBar
					handleDrawerToggle={handleDrawerToggle}
					show={showCustomAppBar}
					sideBarMenuShow={showMobileSideBar}
				/>
				<Grid
					id={"content-page"}
					container
					padding={{ xs: 1, sm: 1, md: 3 }}
					paddingTop={
						showCustomAppBar ? "0px !important" : { xs: 1, sm: 1, md: 3 }
					}
					sx={{
						minHeight: `${contentPageMinHeight}px`,
					}}
				>
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						<Routes>
							{adminroutes?.map((item, index) => (
								<Route
									key={`${index}-admin-routes-${item?.path}`}
									//   caseSensitive={item?.exact}
									path={item?.path}
									element={<PrivateRoute element={item?.component} />}
								/>
							))}
						</Routes>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}

export default AdminPortal;
